export default (v) => {
  if (v === '') return true
  if (!v) return false
  return typeof v.valueOf() === 'string'
}
